
import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'   // eslint-disable-line
import { MediaService } from '@/services/index'
import { IPlatform } from '@/types/media-types'

@Component({
    name: 'AddPlatform',
    components: {
    }
})
export default class extends Vue {
    private visible: boolean = false
    private loading: boolean = false
    private addPlatformCb: any = null
    private mediaId: number = 0
    private platform: any = {}
    private media: any = {}
    private curTab = 'sql'
    private selectStatus = 'unselected'
    private sqlForm = {
        name: '',
        mp_type_id: '',
        mp_user_id: '',
        medium_id: '',
        mp_medium_id: '',
        mp_url: '',
        medium_name: ''
    }
    private suggestions: any[] = []
    private crawlerScript: Record<number, string> = {
        1: 'toutiaohao_script',
        2: 'wechat_script',
        3: 'weibohao_script',
        4: 'qiehao_script',
        5: 'baijiahao_script',
        6: 'wangyihao_script',
        7: 'souhuhao_script',
        8: 'dayuhao_script',
        9: 'dafenghao_script',
        10: 'a1_script',
        11: 'xpath_script',
        14: 'easymoney_script',
        15: 'nfhao_script',
        16: 'people_script',
        24: 'xinlangkandian_script',
        25: 'kuaichuanhao_script',
        27: 'chudian_script',
        51: 'douyin_script',
        53: 'bilibili_script',
        55: 'haokan_script'
    }

    private infoRules = {
        name: [
            { required: true, message: '请输入媒体平台账号名称', trigger: 'blur' }
        ]
    }

    private addRules = {
        name: [
            { required: true, message: '请输入 name', trigger: 'blur' }
        ],
        mp_user_id: [
            { required: true, message: '请输入 mp_user_id', trigger: 'blur' }
        ]
    }


    private show(mediaId: number, platform: IPlatform, media: any, addPlatformCb: Function) {
        this.visible = true
        this.mediaId = mediaId
        this.platform = platform
        this.media = media
        this.addPlatformCb = addPlatformCb
    }

    private close() {
        this.visible = false
        if (this.addPlatformCb) {
            this.addPlatformCb()
        }
        this.sqlForm.name = ''
        this.sqlForm.mp_user_id = ''
        this.sqlForm.mp_medium_id = ''
        this.sqlForm.mp_url = ''
    }

    private cleanStatus() {
        this.selectStatus = 'unselected'
        this.sqlForm.name = ''
        this.sqlForm.mp_user_id = ''
        this.sqlForm.mp_medium_id = ''
        this.sqlForm.mp_url = ''
    }

    private onSubmit(){
        if (this.selectStatus === 'selected' || this.curTab === 'sql') {
            (this.$refs.sqlForm as ElForm).validate(async(valid: boolean) => {
                if (valid) {
                    this.loading = true
                    const params = {
                        name: this.sqlForm.name,
                        medium_id: this.mediaId,
                        mp_type_id: this.platform.id,
                        mp_user_id: this.sqlForm.mp_user_id,
                        mp_medium_id: this.sqlForm.mp_medium_id || undefined,
                        mp_url: this.sqlForm.mp_url || undefined,
                        status: 1
                    }
                    const result = await MediaService.addMpAccount(params)
                    if (result.status === 200) {
                        this.$message({ type: 'success', message: '新增成功' })
                        this.close()
                    } else {
                        this.$message({ type: 'error', message: result.message })
                    }
                    this.loading = false
                } else {
                    return false
                }
            })
        }
        else {
            this.addKeyword()
        }
    }

    private async querySearch(queryString: string, cb: (arg: any[]) => void) {
        if (!queryString) {
            cb([])
            return
        }


        if (!(this.platform.id in this.crawlerScript)) {
            cb([])
            return
        }

        const params = {
            keyword: queryString,
            crawlerScript: this.crawlerScript[this.platform.id]
        }
        try {
            const result = await MediaService.getTasks(params)
            if (result.status === 200) {
                this.suggestions = result.data || []
                const seenOriginIds = new Set<string | undefined>()

                const formatted = this.suggestions.map((item: any) => {
                    const { originId, ...rest } = item
                    const formattedItem = {
                        value: item.name,
                        ...rest
                    }
                    
                    if (originId) {
                        formattedItem.originId = originId
                    }

                    return formattedItem
                })
                    .filter((item: any) => {
                        // 如果 originId 已存在于 Set 中，则过滤掉
                        if (item.originId && seenOriginIds.has(item.originId)) {
                            return false
                        }
                        // 如果是新的 originId，则添加到 Set 中并保留
                        if (item.originId) {
                            seenOriginIds.add(item.originId)
                        }
                        return true
                    })
                cb(formatted)
            } else {
                cb([])
                this.$message({ type: 'error', message: result.message })
            }
        } catch (error) {
            cb([])
            console.error(error)
        }
    }

    private handleSelect(item: any) {
        this.sqlForm.name = item.name
        this.sqlForm.mp_user_id = item.originId
        this.sqlForm.mp_url = item.url || ''
        this.selectStatus = 'selected'
    }

    private onInputChange() {
        this.selectStatus = 'unselected'
    }

    private addKeyword() {
        (this.$refs.sqlForm as ElForm).validate(async(valid: boolean) => {
            if (valid) {
                this.loading = true
                const params = {
                    keyword: this.sqlForm.name
                }
                const result = await MediaService.addSpiderKeyword(params)
                this.updateMedia()
                if (result.status === 200) {
                    this.$message({ type: 'success', message: '新增成功' })
                    this.close()
                } else {
                    this.$message({ type: 'error', message: result.message })
                }
                this.loading = false
            } else {
                return false
            } 
        })
    }

    private async updateMedia(){
        const alias = this.media.alias || []
        alias.push(this.sqlForm.name)
        const params = {
            id: this.mediaId,
            name: this.media.name,
            alias: alias,
            type: this.media.type
        }
        await MediaService.update(params)
    }
}
